import { Box } from "@chakra-ui/react";
import clsx from "clsx";
import React from "react";

interface Props {
	active: boolean;
	hasUnreadMessages: boolean;
}

export function ChatButtonStatusIndicator(props: Props): JSX.Element {
	return (
		<Box
			width={4}
			height={4}
			position={"absolute"}
			top={-4}
			left={-4}
			zIndex={1}
			className={clsx("ClassroomChatButton_statusIndicator", {
				"ClassroomChatButton_statusIndicator--active": props.active,
				"ClassroomChatButton_statusIndicator--hasMessages": props.hasUnreadMessages,
			})}
		></Box>
	);
}
